export default "__VITE_ASSET__B2o2V699__"